var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayer2Disk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 61,
    fill: "black",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 61,
    fill: "#FFCE67",
    fillOpacity: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 63,
    r: 61,
    stroke: "black",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 64C122 93.5472 95.4529 122 62.592 122C29.731 122 4 93.5472 4 64C4 34.4528 29.731 15 62.592 15C95.4529 15 122 34.4528 122 64Z",
    fill: "#FFCE67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer2Disk);
export default __webpack_public_path__ + "static/media/player-2-disk.ffc2a6fe19bb1959b6504b135122e30f.svg";
export { ForwardRef as ReactComponent };